import { render } from "./lhv-select-role.vue?vue&type=template&id=2321638c&scoped=true"
import script from "./lhv-select-role.vue?vue&type=script&lang=js"
export * from "./lhv-select-role.vue?vue&type=script&lang=js"

import "./lhv-select-role.vue?vue&type=style&index=0&id=2321638c&scoped=true&lang=scss"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2321638c"]])

export default __exports__